<template>
  <v-layout justify-left row wrap>
    <v-flex xs12>
      <v-tabs fixed-tabs show-arrows dark color="grey lighten-1">
        <v-tab v-for="(topic, key) in topics" :key="key" ripple :to="topic.to">
          <div><v-icon small :class="['fas', topic.icon]"></v-icon><span class="hidden-xs-only">&nbsp;&nbsp;{{ topic.title }}</span></div>
        </v-tab>
      </v-tabs>
      <v-parallax src="static/bigstock-Team-competing-in-tug-of-war-241670680.jpg" height="300">
        <h2>Team Development</h2>
      </v-parallax>
      <div class="cta-block">Let us customize <router-link to="/contact">a solution for you</router-link></div>
      <v-card>
        <v-container fluid>
          <v-layout row wrap>
            <h3 class="sub-header">The Five Behaviors of a Cohesive Team</h3>
            <p>To achieve real sustainable competitive advantage, organizations need to figure out how to build more cohesive teams.  This course is built on Patrick Lencioni’s “Five Dysfunctions of a Team.”  Participants will experience this development opportunity with their teammates and will take an assessment to evaluate the cohesiveness of their team.  Based on the team results, learners will begin working thru the course to develop the five behaviors:  Trust, productive conflict, commitment, accountability and results.</p>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'team',
  data () {
    return {
      topics: [
        {
          title: 'Business Development / Sales',
          icon: 'fa-university',
          excerpt: 'Offering courses that teach your staff to become better business builders through stronger customer relationships, better performance evaluation and bonded team dynamics.',
          to: '/topics/business'
        },
        {
          title: 'Leadership Development',
          icon: 'fa-hand-point-right',
          excerpt: 'Learn the difference between being a manager and being a leader, and how to talk to people at all levels of the organization in ways that engage and strengthen.',
          to: '/topics/leadership'
        },
        {
          title: 'Team Development',
          icon: 'fa-users',
          excerpt: 'Organizations need to learn how to build cohesive teams if they expect to build a sustainable business enterprise by guaging the members.',
          to: '/topics/team'
        },
        {
          title: 'Management Development',
          icon: 'fa-user-tie',
          excerpt: 'Each manager is as individual in style as they are in personality. Each manager can develop those individual traits to their best advantage.',
          to: '/topics/management'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/topics/Team.vue